import { attachOriginals, buildTextFromMessageValue } from "./messageOriginals"

export const generateWriteAMemberActions = (messageValues, globalFormValues, props) => {
    return messageValues.reduce((acc, value) => {
        const gsaInfo = {
            subject: value.subject,
            text: [value.prebody, value.body, value.postbody].filter((text) => text).join("\n\n"),
            campaign: DjangIO.app.grassroots.campaign.models.Campaign.resourceUriFromId(props.campaign.id),
            supporter_action_type: props.campaign.campaign_type,
            message_group_id: props.messageGroups?.length ? value?.message_group_id : null,
        }

        if (!value.target.is_custom) {
            gsaInfo["person"] = DjangIO.app.person.models.Person.resourceUriFromId(value.target.id)
        } else {
            gsaInfo["custom_person"] = value.target.id
        }

        // Attach originals under feature flag (Write a Letter / Interactive behavior)
        attachOriginals(gsaInfo, {
            allowVariation: true,
            defaultTemplateGetter: () => value.original_template_text ?? buildTextFromMessageValue(value),
            variationIdGetter: () =>
                value.message_variation_id ??
                value.variation_id ??
                props?.targetedMessages?.[value?.message_group_id]?.raw?.variation_id ??
                props?.campaign?.messages?.[value?.message_group_id]?.raw?.variation_id ??
                null,
        })

        acc.push(gsaInfo)

        return acc
    }, [])
}

export const generatePersonalizedMessagesActions = (messageValues, globalFormValues, props) => {
    const actions = generateWriteAMemberActions(messageValues, globalFormValues, props)
    actions.map((action) => {
        action["tag_dict"] = props.tag_dict
        return action
    })
    return actions
}

export const generateCombinedCampaignActions = (messageValues, globalFormValues, props) => {
    return messageValues.reduce((acc, value) => {
        const campaignId = value.get("campaignId")

        const gsaInfo = {
            text: [value.get("prebody"), value.get("body"), value.get("postbody")].filter((text) => text).join("\n\n"),
            subject: value.get("subject"),
            campaign: DjangIO.app.grassroots.campaign.models.Campaign.resourceUriFromId(campaignId),
            supporter_action_type: props.extraMessageData.getIn([campaignId.toString(), "campaign_type"]),
        }

        if (!value.getIn(["target", "is_custom"]) && value.getIn(["target", "id"])) {
            gsaInfo["person"] = DjangIO.app.person.models.Person.resourceUriFromId(value.getIn(["target", "id"]))
        }

        // Attach originals for combined campaigns if provided in value (immutable)
        attachOriginals(gsaInfo, {
            allowVariation: true,
            defaultTemplateGetter: () => value.get("original_template_text") ?? buildTextFromMessageValue(value),
            variationIdGetter: () => {
                const direct = value.get("message_variation_id") ?? value.get("variation_id")
                if (direct != null) return direct
                try {
                    const campaignId = String(value.get("campaignId"))
                    const targetId = value.getIn(["target", "id"])
                    const match = props?.messages?.find?.(
                        (m) => String(m?.campaign_id) === campaignId && m?.target?.id === targetId,
                    )
                    return match?.variation_id ?? null
                } catch (_) {
                    return null
                }
            },
        })

        acc.push(gsaInfo)

        return acc
    }, [])
}

export const generateCommentOnRegulationActions = (messageValues, globalFormValues, props) => {
    return messageValues.reduce((acc, value) => {
        const submittingOrg = globalFormValues.submitting_org_name ?? value.submitting_org_name
        const gsaInfo = {
            text: [value.prebody, value.body, value.postbody].filter((text) => text).join("\n\n"),
            campaign: DjangIO.app.grassroots.campaign.models.Campaign.resourceUriFromId(props.campaign.id),
            supporter_action_type: props.campaign.campaign_type,
            ...(submittingOrg ? { submitting_org_name: submittingOrg } : {}),
        }
        // Regulations: no variations; attach only original_template_text
        attachOriginals(gsaInfo, {
            allowVariation: false,
            defaultTemplateGetter: () => value.original_template_text ?? buildTextFromMessageValue(value),
        })
        acc.push(gsaInfo)
        return acc
    }, [])
}

export const generateVisitOfficeActions = (messageValues, globalFormValues, props) => {
    return messageValues.reduce((acc, value) => {
        const gsaInfo = {
            text: [value.get("prebody"), value.get("body"), value.get("postbody")].filter((text) => text).join("\n\n"),
            subject: value.get("subject"),
            person: DjangIO.app.person.models.Person.resourceUriFromId(value.getIn(["target", "id"])),
            campaign: DjangIO.app.grassroots.campaign.models.Campaign.resourceUriFromId(props.campaign.id),
            supporter_action_type: props.campaign.campaign_type,
        }
        // Visit office uses immutable values; attach originals only if helpful (no variation)
        attachOriginals(gsaInfo, {
            allowVariation: false,
            defaultTemplateGetter: () => value.get("original_template_text") ?? buildTextFromMessageValue(value),
        })
        acc.push(gsaInfo)

        return acc
    }, [])
}

export const generateWriteWhiteHouseActions = (messageValues, globalFormValues, props) => {
    return messageValues.reduce((acc, value) => {
        const gsaInfo = {
            text: [value.prebody, value.body, value.postbody].filter((text) => text).join("\n\n"),
            subject: value.subject,
            campaign: DjangIO.app.grassroots.campaign.models.Campaign.resourceUriFromId(props.campaign.id),
            supporter_action_type: props.campaign.campaign_type,
        }
        // White House: no variations; attach only original_template_text
        attachOriginals(gsaInfo, {
            allowVariation: false,
            defaultTemplateGetter: () => value.original_template_text ?? buildTextFromMessageValue(value),
        })
        acc.push(gsaInfo)
        return acc
    }, [])
}
